var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"content_loader"},[_c('div',{staticClass:"loader-content"},[_c('div',{staticClass:"loader-circle"}),_vm._v(" "),_c('div',{staticClass:"loader-line-mask"},[_c('div',{staticClass:"loader-line"})]),_vm._v(" "),_c('img',{attrs:{"src":require("../../assets/loader.png")}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54dcbd36","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/loader.vue
// module id = 882
// module chunks = 1 3